import { appDomain } from "commonAssets/js/constants";

/**
 * Converts a claim deadline to a formatted string.
 * @param {string} claim_deadline - The claim deadline to be formatted.
 * @returns {string} The formatted claim deadline.
 */
export function uniformClaimDeadline(claim_deadline) {
    if (!claim_deadline) return;
    const deadline = new Date(claim_deadline).toLocaleString("en-US", {
        timeZone: appDomain.options.claimDeadlineTimezone,
        month: "long",
        day: "numeric",
        year: "numeric",
        hour: "numeric",
        minute: "numeric",
        hour12: true,
    });
    return deadline;
}
